export const TIMELINE_BASE_DAY_WIDTH = 1600;
export const TIMELINE_MINUTES_IN_DAY = 24 * 60;
export const TIMELINE_SNAP_INTERVAL_MINUTES = 30;
export const TIMELINE_RESOURCE_ROW_HEIGHT = 60;
export const TIMELINE_GROUP_HEADER_HEIGHT = 32;
export const TIMELINE_RESOURCE_COLUMN_WIDTH = 200;
export const TIMELINE_HEADER_HEIGHT = 60;
export const TIMELINE_DATE_HEADER_HEIGHT = 32;
export const TIMELINE_HOUR_HEADER_HEIGHT = 28;

// Per-lane vertical allotment when a resource has overlapping events. Rows
// expand to fit (laneCount * TIMELINE_LANE_HEIGHT_PX) + padding so each event
// stays comfortably tall regardless of stacking depth.
export const TIMELINE_LANE_HEIGHT_PX = 32;
export const TIMELINE_LANE_VERTICAL_PADDING_PX = 6;
export const TIMELINE_EVENT_MIN_WIDTH = 20;
export const TIMELINE_EVENT_MIN_HEIGHT = 12;
export const TIMELINE_EVENT_BORDER_RADIUS = 4;
export const TIMELINE_EVENT_DRAG_HANDLE_WIDTH = 12;
export const TIMELINE_EVENT_TITLE_LEFT_PADDING = 8;
export const TIMELINE_EVENT_TITLE_DRAG_LEFT_PADDING = 18;
export const TIMELINE_EVENT_TITLE_RIGHT_PADDING = 18;
export const TIMELINE_EVENT_CONTINUATION_FADE_WIDTH = 18;
export const TIMELINE_EVENT_CONTINUATION_ARROW_GUTTER = 4;
